import clsx from 'clsx';
import React from 'react';

export { HueGlyph } from '../../ui/v2';

/** Editorial serif for the greeting and the performance headline. */
export const serif = 'font-v2-display';

/** Pulsing presence dot. Only for a live state, never a stale timestamp. */
export const LiveDot: React.FC<{ className?: string }> = ({ className }) => (
  <span aria-hidden className={clsx('relative flex h-2 w-2', className)}>
    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-v2-success opacity-50 motion-reduce:animate-none" />
    <span className="relative inline-flex h-2 w-2 rounded-full bg-v2-success" />
  </span>
);
